import React from 'react'
import { Grid } from '@mui/material'
import * as R from 'ramda'

import i18n from '../../../../locales/i18n'
import { TableFilter } from '../../../../types'
import AppliedFilter from './AppliedFilter'

const clearFilter = {
  humanReadable: i18n.t('Common:CLEAR_ALL'),
  value: null,
}

export type SortingType = {
  humanReadableName: string
  sortingName: string
}
interface AppliedFiltersProps {
  readonly filters?: Record<string, TableFilter>
  readonly onClearFilters: () => void
  readonly onRemoveFilter: (name: string) => void
  readonly onRemoveSorting?: (name: string) => void
  readonly sortings?: SortingType[]
  readonly useNilAsEmpty: boolean
}

const AppliedFilters = ({
  filters: filtersProp,
  sortings: sortingsProp,
  useNilAsEmpty,
  onClearFilters,
  onRemoveFilter,
  onRemoveSorting,
}: AppliedFiltersProps) => {
  const filters = filtersProp || {}
  const sortings = sortingsProp || []
  const emptyFunc = useNilAsEmpty ? R.isNil : R.either(R.isNil, R.isEmpty)
  const appliedFilters = R.filter(
    filter =>
      !emptyFunc(filter?.value) &&
      (!emptyFunc(filter?.humanReadable) || !emptyFunc(filter?.component)),
    filters,
  )
  const keys = Object.keys(appliedFilters)
  const totalKeys = sortings.length + keys.length

  if (totalKeys === 0) {
    return null
  }

  return (
    <Grid container item>
      {keys.map(filterName => (
        <AppliedFilter
          filter={appliedFilters[filterName]}
          key={filterName}
          onClick={() => onRemoveFilter(filterName)}
        />
      ))}
      {onRemoveSorting &&
        sortings.map(({ humanReadableName, sortingName }) => (
          <AppliedFilter
            filter={{ humanReadable: humanReadableName }}
            key={sortingName}
            onClick={() => onRemoveSorting(sortingName)}
          />
        ))}
      {totalKeys > 1 && onClearFilters && (
        <AppliedFilter filter={clearFilter} onClick={onClearFilters} />
      )}
    </Grid>
  )
}

export default AppliedFilters
